/* Karchir — arama sorgusunu düzelt (Tur 74)

   SORUN (Batuhan, 17 Eyl): "kız takım" araması erkek ürünlerini de getiriyor.
   ÖLÇÜM (analiz/k-arama-sayfa.js, canlı mağaza):
     q = "kız takım"            -> 13 sonuç (tüm ürünler; "takım" hepsinde var)
     q = "kız AND takım"        -> 13 sonuç (Shopify arama sayfası AND'i yok sayıyor)
     q = "\"kız takım\""        -> 13 sonuç (tırnak da işe yaramıyor)
     q = "tag:kiz takım"        -> 10 sonuç, hepsi kız  ✔
     q = "tag:erkek eşofman"    -> 2 sonuç, hepsi erkek ✔
   Yani Shopify'ın sonuç sayfası kelimeleri VEYA ile arıyor; tek çözüm
   cinsiyeti "tag:" ile alana bağlamak. (Açılır öneri kutusu zaten doğruydu,
   sorun yalnız tam sonuç sayfasındaydı.)

   Etiketler ASCII: kiz / erkek. Kullanıcı "kız" yazsa da eşleştiriyoruz.
   Form gönderilmeden önce yalnız cinsiyet kelimesi değiştirilir; diğer
   kelimelere dokunulmaz. Kutuda yazan metin değişmez, yalnız gönderilen
   sorgu değişir. */
(function () {
  'use strict';

  var KIZ = ['kız', 'kiz', 'kızlar', 'kizlar', 'kıza', 'kiza', 'kız çocuk', 'kiz cocuk'];
  var ERKEK = ['erkek', 'erkekler', 'erkeğe', 'erkege', 'erkek çocuk', 'erkek cocuk'];

  function sadelestir(kelime) {
    return kelime
      .toLocaleLowerCase('tr')
      .replace(/[.,;:!?'"()]/g, '')
      .trim();
  }

  /* "kız takım" -> "tag:kiz takım" */
  function sorguyuCevir(ham) {
    if (!ham) return ham;
    // Kullanıcı zaten tag: yazdıysa karışma
    if (/(^|\s)tag:/i.test(ham)) return ham;

    var parcalar = ham.split(/\s+/).filter(Boolean);
    var etiketler = [];
    var kalan = [];

    for (var i = 0; i < parcalar.length; i++) {
      var s = sadelestir(parcalar[i]);
      if (KIZ.indexOf(s) !== -1) {
        if (etiketler.indexOf('tag:kiz') === -1) etiketler.push('tag:kiz');
      } else if (ERKEK.indexOf(s) !== -1) {
        if (etiketler.indexOf('tag:erkek') === -1) etiketler.push('tag:erkek');
      } else {
        kalan.push(parcalar[i]);
      }
    }

    if (!etiketler.length) return ham;
    // Hem kız hem erkek yazılmışsa cinsiyet süzmenin anlamı kalmıyor
    if (etiketler.length > 1) return ham;

    return etiketler.concat(kalan).join(' ');
  }

  document.addEventListener(
    'submit',
    function (olay) {
      var form = olay.target;
      if (!form || form.tagName !== 'FORM') return;
      var adres = form.getAttribute('action') || '';
      if (adres.indexOf('/search') === -1) return;

      var kutu = form.querySelector('input[name="q"]');
      if (!kutu || !kutu.value) return;

      var yeni = sorguyuCevir(kutu.value);
      if (yeni === kutu.value) return;

      /* Kutudaki yazıyı bozmadan göndermek için gizli bir alan kullanılamaz
         (aynı ada iki alan olursa ikisi de gider). Değeri değiştirip
         gönderiyoruz; sayfa yenilendiği için kullanıcı bunu görmüyor. */
      kutu.value = yeni;
    },
    true
  );

  /* Sonuç sayfasında kutuda "tag:kiz takım" yazmasın: okunur hale getir. */
  function kutulariTemizle() {
    var kutular = document.querySelectorAll('input[name="q"]');
    for (var i = 0; i < kutular.length; i++) {
      var v = kutular[i].value;
      if (!v || v.indexOf('tag:') === -1) continue;
      kutular[i].value = v
        .replace(/tag:kiz/gi, 'kız')
        .replace(/tag:erkek/gi, 'erkek')
        // Tur 146: popüler arama hapı "tag:eşofman" → kutuda "eşofman"
        .replace(/tag:/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kutulariTemizle);
  } else {
    kutulariTemizle();
  }
})();
